const { invalid } = require("moment");

let validateParentAwbArray = function (arrParentAwbNo) {
    return new Promise((resolve, reject) => {
        try {
            let validShipment = []
            let invalidShipment = []
            let regexSurface = new RegExp('^1|^9169 |^2|^5|^6|^7|^9|^M')
            let regexSurfacetest = new RegExp('^9 | ^9169 | ^7 | 7167 | ^I5 | ^G8 | ^9W | ^UK | ^SG | ^AI | ^LB | ^BZ | ^GE')
            let regexAir = new RegExp('^1|^9169 |^2|^7167|^5|^6|^7|^9|^M')

            let regexAirAsia = new RegExp("^I5", "i");
            let regexGoAir = new RegExp("^G8", "i");
            let regexJetAirways = new RegExp("^9W", "i");
            let regexVistara = new RegExp("^UK", "i");

            let regexSpiceJet = new RegExp("^SG", "i");
            let regexAirIndia = new RegExp("^AI", "i");
            let regexGoAirCosta = new RegExp("^LB", "i");
            let regexBlueDart = new RegExp("^BZ", "i");
            let regexIndigo = new RegExp("^GE", "i");
            arrParentAwbNo.forEach(element => {
                let shipmentElement = element.trim() || null
                if (shipmentElement) {
                    if (shipmentElement.length >= 8 && shipmentElement.length <= 16) {
                        if (regexSurface.test(shipmentElement) || regexAir.test(shipmentElement) || regexAirAsia.test(shipmentElement) || regexGoAir.test(shipmentElement) ||
                            regexJetAirways.test(shipmentElement) || regexVistara.test(shipmentElement) || regexSpiceJet.test(shipmentElement) || regexAirIndia.test(shipmentElement)
                            || regexGoAirCosta.test(shipmentElement) || regexBlueDart.test(shipmentElement) || regexIndigo.test(shipmentElement)) {
                            validShipment.push(shipmentElement)
                        } else {
                            invalidShipment.push(shipmentElement)
                        }
                    } else {
                        invalidShipment.push(shipmentElement)
                    }
                } else {
                    if (shipmentElement) {
                        invalidShipment.push(shipmentElement)
                    }
                }
            });
            console.log(`Valid ${validShipment} invalid ${invalidShipment}`);
            return resolve({ status: 200, valid: validShipment, invalid: invalidShipment })

        } catch (error) {
            reject("ERROR", error);
        }
    })
}

let validateBatchId = function (arrBatchid) {
    return new Promise((resolve, reject) => {
        try {
            let validBatchid = []
            let invalidBatchid = []
            let regexBatchid = new RegExp('^RTO|^DTO |^P|^H|^RVP')
            arrBatchid.forEach(element => {
                let BatchElement = element.trim() || null
                if (BatchElement) {
                    if (BatchElement) {
                        if (regexBatchid.test(BatchElement) ) {
                            validBatchid.push(BatchElement)
                        } else {
                            invalidBatchid.push(BatchElement)
                        }
                    } else {
                        invalidBatchid.push(BatchElement)
                    }
                } else {
                    if (BatchElement) {
                        invalidBatchid.push(BatchElement)
                    }
                }
            });
            console.log(`valid ${validBatchid} invalid ${invalidBatchid}`);
            return resolve({ status: 200, valid: validBatchid, invalid: invalidBatchid })

        } catch (error) {
            reject("ERROR", error);
        }
    })
}

let formatDate = function (date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
}
module.exports = {
    validateParentAwbArray,
    formatDate,
    validateBatchId
}


// WEBPACK FOOTER //
// ./src/common/common.service.js